<template>
  <div id="app">
    <template v-if="isDownloadCenter">
      <router-view></router-view>
    </template>
    <template v-else>
      <base-nav />
      <base-header :style="headerStyle()"/>
      <div class="main-content">
        <transition :name="transitionName" mode="out-in">
          <keep-alive include="CruiseSearch,CruiseDetail">
            <router-view></router-view>
          </keep-alive>
        </transition>
      </div>

      <base-footer :style="footerStyle()"/>

      <Popup :isShow="isShowPopup" :currentRule="currentRuleText" :onClose="closePopup"></Popup>
      <privacy-modal v-model="isShowPrivacy" @submit="submitAgreePrivacyPolicy"></privacy-modal>
    </template>
  </div>
</template>

<script>
import api from '@/api'
const BaseHeader = () => import('./components/BaseHeader.vue')
const BaseFooter = () => import('./components/BaseFooter.vue')
const BaseNav = () => import('./components/BaseNav.vue')
import Popup from '@/components/Popup'
import wechatHelper from '@/utilities/wechatHelper'
import Cookies from 'js-cookie'
import { isMobile, gioTracking } from '@/utilities/tools'
const PrivacyModal = () => import('@/components/Common/PrivacyModal')
const AGREE_PRIVACY = "AGREE_PRIVACY";
export default {
  name: 'App',
  components: {
    BaseHeader,
    BaseFooter,
    BaseNav,
    Popup,
    PrivacyModal
  },
  data () {
    return {
      transitionName: '',
      isShowPopup: false,
      currentRuleText: '',
      isShowPrivacy: false
    }
  },
  created () {
    let linkStr = window.location.href.toLowerCase();
    if(linkStr.indexOf('wz_index_law_privacy') < 0 && linkStr.indexOf('wz_index_law') < 0) {
      this.initPrivacyPolicy()
    }
    try {
      if (!isMobile()) {
        console.log('is not mobile')
        return location.href = `${process.env.VUE_APP_PC_URL}${location.pathname}${location.search}` 
      }
    } catch (e) {
      console.error(e)
    }
    this.autoLogin()
    
    try {
      if (wechatHelper.isWeixinBrowser()) {
        wechatHelper.wechatSdkConfig()
        
        const openId = this.$store.state.user.wechatOpenId
        if (!openId || openId == '') {
          const query = this.$router.currentRoute.query
          if ((!query.fromMiniProgram || query.fromMiniProgram == 'false')
          && this.$router.currentRoute.name != 'WechatAuth'
          && this.$router.currentRoute.name.indexOf("Login")) {
            
            return wechatHelper.wechatAuth()
          }
        } 
      }
    } catch (e) {
      console.error(e)
    }
  },
  mounted() {
    const userToken = this.$store.state.user.userToken
    if (userToken && userToken.length > 0) {
      this.$store.dispatch('GET_SHOPPING_CART_COUNT', userToken)
    }
    this.trackingCode()
  },
  methods: {
    autoLogin () {
      const userToken = this.$store.state.user.userToken
      if (!userToken || userToken.length == 0) {
        const auth = Cookies.get('authed', { path: "/" })
        if (auth == "1" && location.href.toLowerCase().indexOf("auth") < 0) {
          const authUrl = encodeURIComponent(`${process.env.VUE_APP_BASE_URL}/Orchard.Rccl.Users/Auth/Index`)
          const redirectUrl = encodeURIComponent(location.href)
          const autoLoginUrl = `${process.env.VUE_APP_API_BASE_URL}/Rccl.Campaign/RedirectToTui/Auth`
          + `?authUrl=${authUrl}&redirectUrl=${redirectUrl}&campaignId=${process.env.VUE_APP_API_KEY}`
          console.log("auto login")
          Cookies.remove('authed')
          return location.href = autoLoginUrl
        }
      }
    },
    trackingCode () {
      const query = this.$router.currentRoute.query
      const hmsr = query.hmsr || ''
      const hmpl = query.hmpl || ''
      const hmcu = query.hmcu || ''
      const hmci = query.hmci || ''
      const hmkw = query.hmkw || ''
      this.$store.commit('SET_TRACKING', { hmsr, hmpl, hmcu, hmci, hmkw })

      try {
        const route = this.$route
        const query = route.query
        if(query && query.cs6 && query.cs6.length > 0){
          window.gio('app.set','MessageID', query.cs6.toString())
        }
      } catch (error) {
        console.error(error)
      }
    },
    headerStyle() {
      if (this.$store.state.page.isHideHeader) {
        return { 'display': 'none !important'}
      }else {
        return {}
      }
    },
    footerStyle() {
      if (this.$store.state.page.isHideFooter) {
        return { 'display': 'none !important'}
      }else {
        return {}
      }
    },
    closePopup () {
      this.$store.state.page.isShowPopup = false
    },
    // 初始化是否同意过最新隐私政策
    async initPrivacyPolicy() {
      this.userName = this.$store.state.user.userToken;
      // let isAgreePrivacy = window.sessionStorage.getItem(AGREE_PRIVACY);
      // 用户已经登录进行验证
      if(this.userName) {
        const { success, data, errMsg } = await api.user.getUserVersionIsEffective(this.userName);
        if(success) {
          // window.sessionStorage.setItem(AGREE_PRIVACY, data ? "true" : "false");
          this.isShowPrivacy =! data;
        } else {
          this.$alert.show(errMsg)
        }
        // 已经同意最新隐私政策 true-同意，false-不同意
        // if(isAgreePrivacy === "true") {
        //   this.isShowPrivacy = false;
        // } else {
        //
        // }
      } else {
        this.isShowPrivacy = false;
      }
    },
    /**
     * 同意隐私政策提交
     * @param isAgree true-同意，false-不同意
     */
    async submitAgreePrivacyPolicy(isAgree) {
      if(isAgree) {
        const { success, errMsg } = await api.user.agreePrivacyPolicy(this.userName);
        if(success) {
          window.sessionStorage.setItem(AGREE_PRIVACY, "true");
          this.isShowPrivacy = false;
        } else {
          this.$alert.show(errMsg)
        }
      } else {
        this.logout();
      }
    },
    logout() {
      this.isShowPrivacy = false;
      window.sessionStorage.setItem(AGREE_PRIVACY, "null");
      this.$store.commit("REMOVE_USER_TOKEN");
      this.$router.push(
          `/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(
              window.location.pathname
          )}`
      );
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo
    },
    isDownloadCenter() {
      return this.$route.meta.isDownloadCenter;
    }
  },
  watch: {
    '$route' (to, from) {
      let className = 'slide-left'
      if (this.$store.state.page.depthHistory.indexOf(to.path) > -1 || to.path === '/') {
        className = 'slide-right'
        this.$store.commit('UPDATE_DEPTH_HISTORY', to.path)
      } else {
        this.$store.commit('UPDATE_DEPTH_HISTORY', from.path)
      }
      if (from.meta.index === undefined && to.meta.index === 1) {
        className = ''
      }
      this.transitionName = className
    },
    '$store.state.page.isShowPopup' (newVal) {
      this.isShowPopup = newVal
    },
    '$store.state.page.popupContent' (newVal) {
      this.currentRuleText = newVal
    },
    userInfo (userInfo) {
      if (window.gio && userInfo && userInfo.cmsId > 0) {
        gioTracking('setUserId', userInfo.cmsId)
        if (userInfo.localRewardId) {
          gioTracking('people.set', userInfo.localRewardId);
        }
        gioTracking('app.set', 'ID', userInfo.cmsId)
      }
    }
  },
}
</script>

<style>

@import "./styles/main.css";
@import './styles/common.css';

body {
    overflow: initial;
    height: auto;
    background: #F6F7F8;
}

.main-content {
  margin-top: 50px;
}

nav.home-bar-nav {
  position: fixed;
}

div.footer-nav {
  position: fixed;
}

.slide-fade-enter-active {
  transition: all .1s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(-10px);
}

.slide-right-enter, .slide-left-leave-to {
  opacity: 0;
  transform: translateX(-10%);
}
.slide-right-leave-to, .slide-left-enter {
  opacity: 0;
  transform: translateX(10%);
}
.slide-right-enter-active, .slide-right-leave-active,
.slide-left-enter-active, .slide-left-leave-active {
  transition: opacity 0.15s ease-out, transform 0.15s ease-out;
}

</style>
